import { Avatar, type AvatarProps } from '@/components/ui/Avatar';

import { useMemberPhotoUrl } from '../../hooks/useMembers';

export interface MemberAvatarProps {
  memberId: number;
  /** The member's `photoPath`; null shows their initials without asking the server. */
  photoPath: string | null;
  name: string;
  size?: NonNullable<AvatarProps['size']>;
  className?: string | undefined;
}

/** A member's photo in a circle, wherever a list shows them; their initials while there is none. */
export function MemberAvatar({
  memberId,
  photoPath,
  name,
  size = 'md',
  className,
}: MemberAvatarProps) {
  const photoUrl = useMemberPhotoUrl(memberId, photoPath);
  return <Avatar name={name} size={size} photoUrl={photoUrl} className={className} />;
}
